import React, { useState, useCallback, useEffect, Fragment } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const ImageCompareSlider = props => {
	const { before, after, subscribeForProgress, initialProgress } = props;
	const [progress, setProgress] = useState(initialProgress || 0.17);
	const [width, setWidth] = useState(100);
	const measuredRef = useCallback(node => {
		if (node !== null) {
			setWidth(node.getBoundingClientRect().width);
		}
	}, []);
	function updateProgress(prog) {
		setProgress(prog);
	}
	useEffect(() => {
		if (typeof subscribeForProgress === 'function') {
			subscribeForProgress(updateProgress);
		}
	}, [subscribeForProgress]);
	return (
		<Fragment>
			<div className="slider-container" ref={measuredRef} style={{ width: '100%' }}>
				<div className="slider-before-wrapper" style={{ width: `${100 * progress}%` }} >
					<img src={before} alt="" className="before" style={{ width }} />
				</div>
				<img src={after} alt="" className="after" />
				<div
					className="slider-content-left"
					style={{ left: `${(100 * progress) - ((96 / width) * 100)}%` }}
				>
					<div>2.06
						<span className="size-suffix">
							MB
						</span> <br />
						<div className="next-line">Source</div>
					</div>
					<LeftOutlined />
				</div>
				<div
					className="slider-content-right"
					style={{ left: `${(100 * progress) - ((-5 / width) * 100)}%` }}
				>
					<RightOutlined />
					<div>147
						<span className="size-suffix">
							KB
						</span> <br />
						<div className="next-line">Compressed</div>
					</div>
				</div>
				<div
					className="slider-content"
				/>
			</div>
		</Fragment>
	);
};
export default ImageCompareSlider;



// WEBPACK FOOTER //
// ./src/components/image-compare/ImageCompareSlider.js